import React from "react";
import "./StatusTimeline.css";

const buildStepClassName = (item) => {
    const classes = ["status-timeline__step", `status-timeline__step--${item.state || "upcoming"}`];

    if (item.tone) {
        classes.push(`status-timeline__step--${item.tone}`);
    }

    return classes.join(" ");
};

const isCompletedStep = (item) => item?.state === "completed" || item?.state === "current";

export default function StatusTimeline({ title, subtitle, items = [] }) {
    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    return (
        <div className="status-timeline">
            {(title || subtitle) && (
                <div className="status-timeline__header">
                    {title && <span className="status-timeline__title">{title}</span>}
                    {subtitle && <span className="status-timeline__subtitle">{subtitle}</span>}
                </div>
            )}

            <div className="status-timeline__viewport">
                <div className="status-timeline__row">
                    {items.map((item, index) => {
                        const nextItem = items[index + 1];
                        const lineClassName = [
                            "status-timeline__line",
                            isCompletedStep(item) && isCompletedStep(nextItem) ? "status-timeline__line--completed" : ""
                        ].join(" ").trim();

                        return (
                            <React.Fragment key={item.key || `${item.label}-${index}`}>
                                <div className={buildStepClassName(item)}>
                                    <div className="status-timeline__icon-shell">
                                        <div className="status-timeline__icon">
                                            <i className={item.iconClass} aria-hidden="true" />
                                        </div>
                                    </div>
                                    <div className="status-timeline__node" />
                                    <span className="status-timeline__label">{item.label}</span>
                                    {item.meta && <span className="status-timeline__meta">{item.meta}</span>}
                                    {item.date && <span className="status-timeline__date">{item.date}</span>}
                                </div>

                                {index < items.length - 1 && <div className={lineClassName} aria-hidden="true" />}
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
